import { gql } from '@apollo/client';
import PrivateEventFragments from '../fragments/privateEvent.fragments';

const LIST_PRIVATE_EVENTS = gql`
  query PrivateEvents($params: ListPrivateEventParams) {
    privateEvents(params: $params) {
      ...PrivateEventFields
      ...PrivateEventPSAFiles
      ...PrivateEventParticipants
      ...PrivateEventBids
      ...PrivateEventSettings
      ...PrivateEventContingencies
      ...PrivateEventMeta
      ...PrivateEventListing 
    }
  }

  ${PrivateEventFragments.fields}
  ${PrivateEventFragments.psaFiles}
  ${PrivateEventFragments.participants}
  ${PrivateEventFragments.bids}
  ${PrivateEventFragments.settings}
  ${PrivateEventFragments.contingencies}
  ${PrivateEventFragments.meta}
  ${PrivateEventFragments.listing}
`;

export default LIST_PRIVATE_EVENTS;
